/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Fee_InternationalInputs */

const en_shipping_fee_international = /** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`International`)
};

const es_shipping_fee_international = /** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internacional`)
};

const fr_shipping_fee_international = /** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`International`)
};

const de_shipping_fee_international = /** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`International`)
};

const id_shipping_fee_international = /** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internasional`)
};

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const ja_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const zh_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const ar_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const it_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const ru_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const pt_shipping_fee_international = en_shipping_fee_international;

/** @type {(inputs: Shipping_Fee_InternationalInputs) => LocalizedString} */
const ko_shipping_fee_international = en_shipping_fee_international;

/**
* | output |
* | --- |
* | "International" |
*
* @param {Shipping_Fee_InternationalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_fee_international = /** @type {((inputs?: Shipping_Fee_InternationalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Fee_InternationalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_fee_international(inputs)
	if (locale === "es") return es_shipping_fee_international(inputs)
	if (locale === "fr") return fr_shipping_fee_international(inputs)
	if (locale === "de") return de_shipping_fee_international(inputs)
	if (locale === "ja") return ja_shipping_fee_international(inputs)
	if (locale === "zh") return zh_shipping_fee_international(inputs)
	if (locale === "ar") return ar_shipping_fee_international(inputs)
	if (locale === "id") return id_shipping_fee_international(inputs)
	if (locale === "it") return it_shipping_fee_international(inputs)
	if (locale === "ru") return ru_shipping_fee_international(inputs)
	if (locale === "pt") return pt_shipping_fee_international(inputs)
	return ko_shipping_fee_international(inputs)
});